import React, { Component } from "react";
//Alert dialog
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import { Box, Modal, Fade } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Lightbox } from "react-modal-image";
import ZoomInIcon from "@material-ui/icons/ZoomIn";

import { getCurrencyIcon } from "../../../Helpers/currencyConverter";
class ProductTextField extends Component {
  state = {
    openExampleImage: false,
  };
  render() {
    const {
      extraField,
      language,
      selectedExtraField,
      themeColor,
      settings,
      extraID,
    } = this.props;

    const hasError = selectedExtraField?.error;

    const buttonList = [["bold", "underline", "italic", "fontColor"]];
    const currencyIcon  = getCurrencyIcon(settings)
    return (
      <div
        id={"extraField" + extraID}
        className="border mt-4 pt-3"
        style={{
          backgroundColor: "white",
          width: "100%",
          height: "100%",
          minHeight: 96,
        }}
      >
        {extraField.image && this.state.openExampleImage && (
          <div>
            <Lightbox
              hideDownload
              medium={extraField.image}
              large={extraField.image}
              alt={language === "arabic" ? extraField.ar_name : extraField.name}
              onClose={() => this.setState({ openExampleImage: false })}
            />
          </div>
        )}

        <div style={{ marginBottom: extraField.larger_text && 10 }}>
          <div
            className="mx-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: language === "arabic" && "row-reverse",
              alignItems: "center",
            }}
          >
            <div
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "normal",
                position: "relative",
                direction: language == "arabic" ? "rtl" : "ltr",
              }}
              className={"text-muted ".concat(
                this.props.language === "english" ? "text-left" : "text-right"
              )}
            >
              {extraField.image && extraField.image_style == "avatar" && (
                <>
                  <ZoomInIcon
                    onClick={() => this.setState({ openExampleImage: true })}
                    style={{
                      position: "absolute",

                      color: themeColor,
                      fontSize: 25,
                      padding: 2,
                      backgroundColor: "hsla(0,0%,100%,.8)",

                      borderRadius: 5,
                    }}
                  />
                  <img
                    onClick={() => this.setState({ openExampleImage: true })}
                    style={{
                      objectFit: "contain",
                      padding: 5,
                      width: 60,
                      height: 60,
                      borderRadius: 10,
                    }}
                    src={extraField.image}
                  />
                </>
              )}
              <span>
                {(language === "arabic" && extraField.ar_name) ||
                  extraField.name}
              </span>
              {extraField.image && extraField.image_style == "icon" && (
                <>
                  {"    "}
                  <InfoOutlinedIcon
                    style={{ color: themeColor, cursor: "pointer", width: 18 }}
                    onClick={() => this.setState({ openExampleImage: true })}
                  />
                </>
              )}
            </div>
            {extraField.price > 0 && (
              <div
                style={{
                  color: themeColor,
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                {extraField.price && " + "}
                <span
                  className={
                    currencyIcon
                  }
                >
                  {extraField.price
                    ? `${
                        language === "arabic"
                          ? settings.currency_local
                          : settings.currency_english
                      } ${extraField.price?.toFixed(
                        settings.currency_decimals
                      )}`
                    : "0.000"}
                </span>
              </div>
            )}
          </div>
        </div>
        {extraField.larger_text ? (
          <div style={{ marginBottom: hasError ? 4 : 0 }}>
            <SunEditor
              autoFocus={false}
              onChange={(e) => {
                this.props.setExtrafield(extraField, e, this.props.groupID);
              }}
              setDefaultStyle={`font-size:15px; font-weight:300;  text-align:${
                language == "english" ? "left" : "right"
              } `}
              defaultValue={selectedExtraField?.value || ""}
              setOptions={{
                height: 150,
                charCounter: true,
                buttonList: buttonList,
                maxCharCount:
                  extraField.character_limit > 0
                    ? extraField.character_limit
                    : null,
                charCounterLabel:
                  extraField.character_limit > 0
                    ? language == "english"
                      ? "Max charachters " + extraField.character_limit
                      : "حد الحروف " + extraField.character_limit
                    : null,
                pasteTagsBlacklist: "script|iframe",
                attributesBlacklist: {
                  "*": "on*",
                },
              }}
            />
            {hasError && (
              <div
                style={{
                  fontSize: "0.75rem",
                  color: "red",
                  marginTop: 4,
                  paddingInlineStart: 4,
                  textAlign: language === "arabic" ? "right" : "left",
                }}
              >
                {language === "arabic"
                  ? "هذه الخانة مطلوبة"
                  : "This field is required"}
              </div>
            )}
          </div>
        ) : (
          <TextField
            fullWidth
            inputProps={{
              maxLength:
                extraField.character_limit > 0
                  ? Math.min(extraField.character_limit, 250)
                  : 250,
            }}
            error={hasError}
            onChange={(e) => {
              this.props.setExtrafield(
                extraField,
                e.target.value,
                this.props.groupID
              );
            }}
            color="primary"
            style={{ width: "90%", marginBlock: 16 }}
            defaultValue={selectedExtraField?.value || ""}
            helperText={
              hasError &&
              (language === "arabic"
                ? "هذه الخانة مطلوبة"
                : "This field is required")
            }
            InputLabelProps={{
              style: {
                right: language == "arabic" && 5,
                left: language == "arabic" && "auto",
              },
              dir: language == "english" ? "ltr" : "rtl",
            }}
            InputProps={{
              dir: language == "english" ? "ltr" : "rtl",
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

export default connect(mapStateToProps)(ProductTextField);
